import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { first } from 'rxjs';

export const blogPostValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const title = control.get('title');
  const content = control.get('content');

  var isValid = false

  if (title != null && title.value != "" && content != null && content.value != "")  {
    isValid = true
  } else {
    isValid = false
  }

  return isValid ? null : { valid: true };
};